import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#0b0b0d]">
      <Navbar />
      <div className="flex-1">{children}</div>
      <Footer />
    </div>
  );
};

export default PublicLayout;